import { DInterfaceAyudaFormulario } from '@dian-cmp/formulario';

export class DAyudasFormulario implements DInterfaceAyudaFormulario {

	MOSTRAR_AYUDAS:boolean = true;
    AYUDAS_FORMULARIO:Array<any> = [
        {
            periodo: 2019,
            ayudas: [
                /*seccion */
                {
                    casilla: 'cs_id_2', 
                    mostrarEn: 'ayuda-obligado', 
                    texto:'<b>2. Concepto.</b> Escriba el código que corresponda al tipo de obligación (Concepto) que vaya a cancelar de acuerdo con la tabla que se incluye en el siguiente numeral.',
                    base: true
                },
                {
                    casilla: 'cs_id_5', 
                    mostrarEn: 'ayuda-obligado', 
                    texto:'<b>5. Número de identificación Tributaria (NIT).</b> Escriba el Número de Identificación Tributaria asignado al contribuyente por la DIAN, sin el dígito de verificación, tal como aparece en la casilla 5 de la hoja principal del certificado del RUT. En ningún caso escriba puntos, guiones o letras.',
                    base: true
                },
                {
                    casilla: 'cs_id_6', 
                    mostrarEn: 'ayuda-obligado', 
                    texto:'<b>6. DV.</b> Escriba el número que en su NIT se encuentra separado, llamado “Dígito  de verificación” (DV), tal como aparece en la casilla 6 de la hoja principal del certificado del RUT.',
                    base: true
                },
                {
                    casilla: 'cs_id_7', 
                    mostrarEn: 'ayuda-obligado', 
                    texto:'<b>7. Primer apellido.</b> Si el contribuyente es persona natural escriba el primer apellido, tal como figura en el documento de identificación, el cual debe coincidir con el registrado en la casilla 31 de la hoja principal del RUT.',
                    base: true
                },
                {
                    casilla: 'cs_id_8', 
                    mostrarEn: 'ayuda-obligado', 
                    texto:'<b>8. Segundo apellido.</b> Si el contribuyente es persona natural escriba el segundo apellido como figura en el documento de identificación el cual debe coincidir con el registrado en la casilla 32 de la hoja principal del RUT.',
                    base: true
                },
                {
                    casilla: 'cs_id_9', 
                    mostrarEn: 'ayuda-obligado', 
                    texto:'<b>9. Primer nombre.</b> Si el contribuyente es persona natural escriba el primer nombre como figura en el documento de identificación, el cual debe coincidir con el registrado en la casilla 33 de la hoja principal del RUT.',
                    base: true
                },
                {
                    casilla: 'cs_id_10', 
                    mostrarEn: 'ayuda-obligado', 
                    texto:'<b>10. Otros nombres.</b> Si el contribuyente es persona natural escriba el segundo nombre como figura en el documento de identificación el cual debe coincidir con el registrado en el RUT, casilla 34 de la hoja principal del RUT.',
                    base: true
                },
                {
                    casilla: 'cs_id_11', 
                    mostrarEn: 'ayuda-obligado', 
                    texto:'<b>11. Razón social.</b> Si el contribuyente es persona jurídica o sociedad de hecho, escriba la razón social completa, o el nombre del consorcio o unión temporal, cuando corresponda a este tipo de obligados, tal como está registrado en el RUT. Esta casilla no debe ser diligenciada cuando la declaración o acto oficial sobre el cual está efectuando el pago corresponda a una persona natural.',
                    base: true
                },         
                {
                    casilla: 'cs_id_12', 
                    mostrarEn: 'ayuda-obligado', 
                    texto:'<b>12. Cód. Dirección Seccional.</b> Registre el código de la Dirección Seccional que corresponda al domicilio principal de su actividad o negocio, según lo informado en la casilla 12 del Registro Único Tributario “RUT”. Verifique que el dato corresponda al último RUT actualizado; si no coincide actualice el RUT antes de presentar la declaración.',
                    base: true
                },        
                {
                    casilla: 'cs_id_24', 
                    mostrarEn: 'ayuda-obligado', 
                    texto:'<b>24. Si es gran contribuyente, marque “X”:</b> Si usted es Gran Contribuyente o a 31 de diciembre fue clasificado como Gran Contribuyente por Resolución del Director de Impuestos y Aduanas Nacionales, señale con una “X” en el recuadro, de lo contrario no diligencie esta casilla. Si usted fue calificado como Gran Contribuyente esta calidad debe estar actualizada en el Registro Único Tributario (Casilla 53 del RUT, responsabilidad 13).',
                    base: true
                },
                /*seccion 2*/
                {
                    casilla: 'cs_id_25', 
                    mostrarEn: 'ayuda-seccion2', 
                    texto:'<b>25. N° Título judicial:</b> Escriba el número del título de depósito judicial que va a utilizar para efectuar el pago, trámite que debe estar soportado con las normas pertinentes. Para uso exclusivo de la DIAN.',
                    base: true
                },
                {
                    casilla: 'cs_id_26', 
                    mostrarEn: 'ayuda-seccion2', 
                    texto:'<b>26. Fecha de depósito:</b> Registre la fecha en que se realizó el depósito judicial en el siguiente orden: Año, mes, día. Si el título proviene de un fraccionamiento, debe colocarse la fecha inicial de consignación.',
                    base: true
                },
                {
                    casilla: 'cs_id_27', 
                    mostrarEn: 'ayuda-seccion2', 
                    texto: '<b>27. Cuota N°.:</b> Registre el número de cuota que va a pagar en este recibo.',
                    base: true
                },
                {
                    casilla: 'cs_id_28', 
                    mostrarEn: 'ayuda-seccion2', 
                    texto: '<b>28. De:</b> Registre el total de número de cuotas en las que tiene derecho a realizar el pago según el decreto de plazos correspondiente.',
                    base: true
                },
                {
                    casilla: 'cs_id_29', 
                    mostrarEn: 'ayuda-seccion2', 
                    texto: '<b>29. No. Formulario:</b> Si la declaración sobre la cual va a efectuar el pago, corresponde al impuesto de renta año gravable 2004 y siguientes, o año calendario 2005 y siguientes para los demás impuestos, diligencie el número que aparece en la casilla número 4 de la declaración correspondiente. Si la declaración sobre la cual va a efectuar el pago, corresponde al impuesto de renta año gravable 2003 y anteriores, o año calendario 2004 y anteriores para los demás impuestos, diligencie en esta casilla el número del autoadhesivo puesto por la entidad recaudadora.',
                    base: true
                },
                {
                    casilla: 'cs_id_30', 
                    mostrarEn: 'ayuda-seccion2', 
                    texto: '<b>30. Acto oficial N°.:</b> Indique el número del acto oficial que va a pagar.',
                    base: true
                },
                {
                    casilla: 'cs_id_31', 
                    mostrarEn: 'ayuda-seccion2', 
                    texto: '<b>31. Fecha del acto oficial:</b> Registre la fecha del acto oficial que va a pagar con este recibo en el siguiente orden: Año, mes, día.',
                    base: true
                },
                {
                    casilla: 'cs_id_32', 
                    mostrarEn: 'ayuda-seccion2', 
                    texto: '<b>32. Fecha para el pago de este recibo:</b> Diligencie la fecha en que va a realizar el pago.',
                    base: true
                },
                {
                    casilla: 'cs_id_33', 
                    mostrarEn: 'ayuda-seccion2', 
                    texto: '<b>33. Cód. Título:</b> Espacio para consignar el código correspondiente si el pago se hace con título valor (Banco); o si el pago se hace por operación sin situación de fondos SIIF.',
                    base: true
                },
                {
                    casilla: 'cs_id_34', 
                    mostrarEn: 'ayuda-seccion2', 
                    texto: '<b>34. Valor pago sanción:</b> Indique la cuantía que va a cancelar por concepto de las sanciones determinadas en la declaración o en el acto oficial sobre el cual está efectuando el pago, incluyendo el valor de la actualización de que trata el artículo 867-1 del Estatuto Tributario, si hay lugar a ello.',
                    base: true
                },
                {
                    casilla: 'cs_id_35', 
                    mostrarEn: 'ayuda-seccion2', 
                    texto: '<b>35. Valor pago intereses de mora:</b> Escriba aquí los intereses a que haya lugar, liquidados a la fecha en que va a efectuar el pago. Hasta el día 25 de diciembre de 2012 el interés moratorio se calculará dentro del contexto del interés compuesto, a partir del 26 de diciembre de 2012, el interés moratorio se liquidará diariamente a la tasa de interés diario que sea equivalente a la tasa de usura vigente determinada por la Superintendencia Financiera de Colombia para las modalidades de crédito de consumo. Las obligaciones insolutas a la fecha de entrada en vigencia de la Ley 1607 de 2012, generarán intereses de mora a la tasa prevista sobre los saldos de capital que no incorporen los intereses de mora generados antes del 26 de diciembre de 2012. A partir de la vigencia de la Ley 1819 de 2016, la tasa de interés moratorio será la tasa de usura vigente determinada por la Superintendencia Financiera de Colombia para las modalidades de crédito de consumo, menos dos (2) puntos.”',
                    base: true
                },
                {
                    casilla: 'cs_id_36', 
                    mostrarEn: 'ayuda-seccion2', 
                    texto: '<b>36. Valor pago impuesto:</b> Indique la cuantía que va a cancelar por concepto de impuestos, correspondientes a la declaración o acto oficial sobre el cual está efectuando el pago.',
                    base: true
                },
                /*seccion deudor solidario*/
                {
                    casilla: 'cs_id_37', 
                    mostrarEn: 'ayuda-deudor', 
                    texto: '<b>37. Tipo de documento:</b> Si el pago lo hace en calidad de deudor solidario o subsidiario, seleccione de la siguiente tabla el tipo de documento de identificación, así: <br>13. Cédula de ciudadanía <br>31. NIT <br>21. Tarjeta de extranjería  <br>41.  Pasaporte <br>22. Cédula de extranjería   <br>42. Documento de identificación extranjero',
                    base: true
                },                
                {
                    casilla: 'cs_id_38', 
                    mostrarEn: 'ayuda-deudor', 
                    texto: '<b>38. Número de identificación:</b> Si seleccionó el código 31 en la casilla 37, para efectuar el pago en calidad de deudor solidario o subsidiario y está inscrito en el RUT, escriba sin el dígito de verificación el Número de Identificación Tributaria asignado por la DIAN, casilla 5 de la hoja principal; en el evento de no estar registrado, escriba el número de su documento de identificación. En ningún caso escriba puntos, guiones o letras.',
                    base: true
                },
                {
                    casilla: 'cs_id_39', 
                    mostrarEn: 'ayuda-deudor', 
                    texto: '<b>39. DV.</b> Si seleccionó el código 31 en la casilla 37, escriba el número que en su NIT se encuentra separado, llamado “Dígito de verificación” (DV), tal como aparece en el certificado del RUT, casilla 6 de la hoja principal. Si no está obligado a inscribirse en el RUT, no diligencie esta casilla.',
                    base: true
                },
                {
                    casilla: 'cs_id_40', 
                    mostrarEn: 'ayuda-deudor', 
                    texto: '<b>40. Primer apellido:</b> Si seleccionó el código 31 en la casilla 37 y el deudor solidario o subsidiario es persona natural, escriba el primer apellido, tal como figura en el documento de identificación, el cual debe coincidir con el registrado en el RUT, casilla 31 de la hoja principal. Si no está obligado a inscribirse en el RUT escriba este dato como figura en su documento de identificación.',
                    base: true
                },
                {
                    casilla: 'cs_id_41',
                    mostrarEn: 'ayuda-deudor', 
                    texto: '<b>41. Segundo apellido:</b> Si seleccionó el código 31 en la casilla 37 y el deudor solidario o subsidiario es persona natural, escriba el segundo apellido como figura en el documento de identificación el cual debe coincidir con el registrado en el RUT, casilla 32 de la hoja principal. Si no está obligado a inscribirse en el RUT, escriba este dato como figura en su documento de identificación.',
                    base: true
                },
                {
                    casilla: 'cs_id_42',
                    mostrarEn: 'ayuda-deudor', 
                    texto: '<b>42. Primer nombre:</b> Si seleccionó el código 31 en la casilla 37 y el deudor solidario o subsidiario es persona natural, escriba el primer nombre como figura en el documento de identificación, el cual debe coincidir con el registrado en el RUT, casilla 33 de la hoja principal. Si no está obligado a inscribirse en el RUT, escriba este dato como figura en su documento de identificación.',
                    base: true
                },
                {
                    casilla: 'cs_id_43',
                    mostrarEn: 'ayuda-deudor', 
                    texto: '<b>43. Otros nombres:</b> Si seleccionó el código 31 en la casilla 37 y el deudor solidario o subsidiario es persona natural, escriba el segundo nombre como figura en el documento de identificación el cual debe coincidir con el registrado en el RUT, casilla 34 de la hoja principal. Si no está obligado a inscribirse en el RUT, escriba este dato como figura en su documento de identificación.',
                    base: true
                },
                {
                    casilla: 'cs_id_44',
                    mostrarEn: 'ayuda-deudor', 
                    texto: '<b>44. Razón social:</b> Si el deudor solidario o subsidiario es persona jurídica o sociedad de hecho, escriba la denominación o razón social completa, como está registrada en el RUT, casilla 35 de la hoja principal.',
                    base: true
                },
                {
                    casilla: 'cs_id_45',
                    mostrarEn: 'ayuda-deudor', 
                    texto: '<b>45. Dirección:</b> Escriba la dirección donde la DIAN pueda ubicar al deudor solidario o subsidiario, la cual debe coincidir con la registrada en el RUT. Si no está obligado a inscribirse en el RUT, escriba la dirección donde se ubique el asiento principal de la actividad o negocio, en todo caso utilice las convenciones que aparecen en la tabla de “Nomenclaturas para dirección”, consulte nuestra página: www.dian.gov. co /Servicio al Ciudadano/formularios/ formularios e instructivos <br>Importante:<br>-   Si no encuentra convención que se ajuste a su dirección, escríbala tal como corresponde.<br>-   El apartado aéreo o nacional en ningún caso reemplaza la dirección.',
                    base: true
                },
                {
                    casilla: 'cs_id_46',
                    mostrarEn: 'ayuda-deudor', 
                    texto: '<b>46. Teléfono:</b> Escriba el número del teléfono donde la DIAN pueda ubicar al deudor solidario o subsidiario, el cual debe coincidir con el informado en el RUT, en las casillas 44 ó 45 de la hoja principal. Si no está obligado a inscribirse en el RUT escriba un número de teléfono donde la DIAN pueda comunicarse con quien efectuó el pago.',
                    base: true
                },
                {
                    casilla: 'cs_id_47',
                    mostrarEn: 'ayuda-deudor', 
                    texto: '<b>47. Cód. Dpto.:</b> Si está inscrito en el Registro Único Tributario, escriba en esta casilla el código relacionado en la casilla 29 de la hoja principal. Si no está obligado      a inscribirse en el RUT, escriba el código que corresponda al departamento del domicilio fiscal del deudor solidario o subsidiario, de acuerdo con el sistema de codificación del territorio nacional generado por el DANE, según la tabla “Código de departamentos”, disponible para consulta en la página web de la DIAN en la siguiente dirección: www.dian.gov.co/Servicio al Ciudadano/formularios/formularios e instructivos',
                    base: true
                },
                {
                    casilla: 'cs_id_48',
                    mostrarEn: 'ayuda-deudor', 
                    texto: '<b>48. Cód Ciudad/Municipio:</b> Si está inscrito en el Registro Único Tributario, escriba en esta casilla el código relacionado en la casilla 40 de la hoja principal. Si no está obligado a inscribirse en el RUT, escriba el código de la ciudad/municipio donde se encuentra ubicada la residencia o domicilio fiscal del deudor solidario o subsidiario, según la tabla “Código de municipios” generada por el DANE disponible para consulta en la página web de la DIAN en la siguiente dirección: www.dian.gov.co /Servicio al Ciudadano /formularios /formularios e instructivos.',
                    base: true
                },                                
                {
                    casilla: 'cs_id_988',
                    mostrarEn: 'ayuda-deudor',
                    texto: '<b>988. Código deudor:</b> Relacione en esta casilla el código asignado al tipo de deudor, así:<br>1.  Solidario, 2. Subsidiario',                    
                    base: true
                },
                /*seccion total*/
                {
                    casilla: 'cs_id_980',
                    mostrarEn: 'ayuda-total',
                    texto: '<b>980. Pago total:</b> Sume casillas 34 a 36.',                    
                    base: true
                }                
            ]
        }    	
    ];

}


// WEBPACK FOOTER //
// D:/github/490/rec_ng_recibopago490v7/src/app/configuracion/dayudas-formulario.ts